//#region IMPORT
import React, { useEffect, useRef } from 'react';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { Dialog } from '../../../../Components/MUIs';
import ConfirmDialog from '../../../../Components/ConfirmDialog';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import {
  Delete as DeleteIcon,
  Download as DownloadIcon,
} from '@mui/icons-material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import BusinessIcon from '@mui/icons-material/Business';
import ApartmentIcon from '@mui/icons-material/Apartment';
import GroupIcon from '@mui/icons-material/Group';
import CategoryIcon from '@mui/icons-material/Category';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DomainIcon from '@mui/icons-material/Domain';
import {
  Box,
  IconButton,
  Stack,
  TextField,
  Typography,
  Button,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tab,
  Tabs,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { getColumnDefs1 } from './TRA_CUSTOM_04_ColumnDefs';

function TRA_CUSTOM_04(props) {
  const gridRef1 = useRef(); // 교육현황
  const searchInfo = useSelector((state) => state.SearchInfo);

  const [tabValue, setTabValue] = React.useState(0); // 탭 상태: 0 = 교육자료, 1 = 교육동영상 (modalToggle1용)
  const [tabValue3, setTabValue3] = React.useState(0); // 탭 상태: 0 = 교육자료, 1 = 교육동영상 (modalToggle3용)
  const columnDefs1 = getColumnDefs1(props);
  const buttonStyle = {
    height: 44,
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    bgcolor: '#7e57c2',
    color: '#fff',
    boxShadow: '0 3px 8px rgba(0,0,0,0.2)',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#5e35b1',
      transform: 'scale(1.05)',
    },
  };

  //#region AuthButton 이벤트
  useEffect(() => {
    if (props.filterClick4) {
      if (!props.validateSelection()) {
        props.setFilterClick4(false);
        return;
      }
      gridRef1.current.api.setQuickFilter(searchInfo.searchText);
      props.setFilterClick4(false);
    }
    if (props.searchClick4) {
      props.ResetLogicAll();
      if (!props.validateSelection()) {
        props.setSearchClick4(false);
        return;
      }
      props.SearchLogic1();
      props.setSearchClick4(false);
    }
    if (props.addClick4) {
      if (!props.validateSelection()) {
        props.setAddClick4(false);
        return;
      }
      GridFunctions.addClick(gridRef1);
      props.setAddClick4(false);
    }
    if (props.saveClick4) {
      if (!props.validateSelection()) {
        props.setSaveClick4(false);
        return;
      }
      props.setSaveClick4(false);
    }
    if (props.deleteClick4) {
      if (!props.validateSelection()) {
        return;
      }
    }
    if (props.printClick4) {
      if (!props.validateSelection()) {
        props.setPrintClick4(false);
        return;
      }
      props.PrintLogic1();
      props.setPrintClick4(false);
    }
  }, [
    props.filterClick4,
    props.searchClick4,
    props.addClick4,
    props.saveClick4,
    props.deleteClick4,
    props.printClick4,
  ]);

  // 팝업이 열릴 때 탭 초기화
  useEffect(() => {
    if (props.modalToggle1) {
      setTabValue(0); // 교육자료 탭으로 초기화
      props.setModalType?.('edu');
    }
    if (props.modalToggle3) {
      setTabValue3(0); // 교육자료 탭으로 초기화
    }
  }, [props.modalToggle1, props.modalToggle3]);

  //#endregion
  return (
    <React.Fragment>
      <BusinessGridCommon
        gridRef={gridRef1}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        setChangedRowData={props.setChangedRowData1}
        setSelectedRowData={props.setSelectedRowData1}
        title1="교육자료 등록 정보"
        addYn1="Y"
        printYn1="N"
        deleteYn1="N"
        addClick1={(e) => {
          if (!props.validateSelection()) return;

          props.PopupClickEvent2();
        }}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
        }}
      />
      {props.modalToggle1 && (
        <Dialog
          title={'교육 자료 및 교육 동영상 등록'}
          open={props.modalToggle1}
          onClose={() => {
            props.setModalToggle1(false);
            props.SearchLogic1?.();
            setTabValue(0); // 팝업 닫을 때 탭 초기화
            props.setModalType?.('edu'); // 모달 타입도 초기화
          }}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            sx: {
              display: 'flex',
              flexDirection: 'column',
              height: '90vh',
              width: '80vw',
              bgcolor: '#f9fafb',
              p: 3,
            },
          }}
          useSaveAfterClose={false}
          closeButtonName="닫기"
          useSaveButton={false}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                height: '100%',
              }}
            >
              {/* 탭 영역 */}
              <Tabs
                value={tabValue}
                onChange={async (e, newValue) => {
                  setTabValue(newValue);
                  const type = newValue === 0 ? 'edu' : 'video';
                  props.setModalType?.(type);

                  // 탭 변경 시 해당 타입의 파일 목록 로드
                  if (props.rowClickData?.current?.depCd) {
                    // loadInitialFile이 타입에 따라 올바른 프로시저를 호출하도록 수정됨
                    await props.loadInitialFile?.(
                      props.rowClickData.current.depCd,
                      type
                    );
                    // 파일 목록도 함께 새로고침
                    await props.loadFileList?.(
                      props.rowClickData.current.depCd,
                      type
                    );
                  }
                }}
                sx={{
                  borderBottom: 2,
                  borderColor: 'divider',
                  mb: 2,
                  '& .MuiTabs-indicator': {
                    height: 3,
                    borderRadius: '3px 3px 0 0',
                  },
                }}
              >
                <Tab
                  label="📄 교육자료"
                  sx={{
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    minHeight: 48,
                    px: 3,
                    color: tabValue === 0 ? '#9c27b0' : '#666',
                    '&.Mui-selected': {
                      color: '#9c27b0',
                    },
                    '&:hover': {
                      color: '#9c27b0',
                      backgroundColor: 'rgba(156, 39, 176, 0.08)',
                    },
                  }}
                />
                <Tab
                  label="📹 교육동영상"
                  sx={{
                    fontWeight: 'bold',
                    fontSize: '1rem',
                    minHeight: 48,
                    px: 3,
                    color: tabValue === 1 ? '#1976d2' : '#666',
                    '&.Mui-selected': {
                      color: '#1976d2',
                    },
                    '&:hover': {
                      color: '#1976d2',
                      backgroundColor: 'rgba(25, 118, 210, 0.08)',
                    },
                  }}
                />
              </Tabs>

              <Box
                sx={{
                  display: 'flex',
                  gap: 3,
                  flex: 1,
                  overflow: 'hidden',
                }}
              >
                {/* 왼쪽: 파일 선택 및 기본정보 */}
                <Paper
                  elevation={4}
                  sx={{
                    width: '50%',
                    p: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 3,
                    bgcolor: '#ffffff',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  <Typography
                    variant="h6"
                    mb={2}
                    sx={{
                      fontWeight: 'bold',
                      color: tabValue === 0 ? '#9c27b0' : '#1976d2',
                    }}
                  >
                    {tabValue === 0
                      ? '📄 교육 자료 업로드'
                      : '📹 교육 동영상 업로드'}
                  </Typography>

                  {/* 파일 선택 영역 */}
                  <Stack spacing={1} sx={{ mb: 2 }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Button
                        variant="contained"
                        component="label"
                        color={tabValue === 0 ? 'secondary' : 'primary'}
                        sx={{
                          bgcolor: tabValue === 0 ? '#9c27b0' : '#2196f3',
                        }}
                      >
                        {tabValue === 0 ? '자료 선택' : '동영상 선택'}
                        <input
                          type="file"
                          hidden
                          accept={
                            tabValue === 0
                              ? '.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.png,.jpg,.jpeg,.hwp'
                              : 'video/*'
                          }
                          onChange={
                            tabValue === 0
                              ? props.handleEduFileChange
                              : props.handleVideoChange
                          }
                        />
                      </Button>
                      <Typography
                        variant="caption"
                        sx={{
                          color: '#666',
                          fontStyle: 'italic',
                          ml: 1,
                        }}
                      >
                        * 업로드 시 저장됩니다
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <TextField
                        size="small"
                        variant="outlined"
                        placeholder={
                          tabValue === 0 ? '교육 자료 파일명' : '동영상 파일명'
                        }
                        value={
                          tabValue === 0
                            ? props.previewFileName || ''
                            : props.videoFile?.name || props.videoFileName || ''
                        }
                        inputProps={{
                          readOnly: true,
                          tabIndex: -1,
                          style: { caretColor: 'transparent' },
                        }}
                        sx={{ flex: 1 }}
                      />
                    </Stack>
                  </Stack>

                  {/* 기본정보 테이블 */}
                  <TableContainer sx={{ maxHeight: 300, mb: 2 }}>
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: 'bold',
                              bgcolor: '#f5f5f5',
                              width: '60px',
                            }}
                          >
                            NO
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: 'bold',
                              bgcolor: '#f5f5f5',
                              minWidth: '300px',
                            }}
                          >
                            파일명
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: 'bold',
                              bgcolor: '#f5f5f5',
                              width: '120px',
                            }}
                          >
                            등록일
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: 'bold',
                              bgcolor: '#f5f5f5',
                              width: '90px',
                            }}
                          >
                            다운로드
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontWeight: 'bold',
                              bgcolor: '#f5f5f5',
                              width: '80px',
                            }}
                          >
                            삭제
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {props.fileList && props.fileList.length > 0 ? (
                          props.fileList.map((row) => (
                            <TableRow
                              key={row.no}
                              hover
                              sx={{
                                '&:hover': {
                                  backgroundColor: '#f5f5f5',
                                },
                              }}
                            >
                              <TableCell
                                align="center"
                                onClick={() => props.handleFileRowClick?.(row)}
                                sx={{ cursor: 'pointer', width: '60px' }}
                              >
                                {row.no}
                              </TableCell>
                              <TableCell
                                align="left"
                                onClick={() => props.handleFileRowClick?.(row)}
                                sx={{ cursor: 'pointer', minWidth: '300px' }}
                              >
                                {row.fileName}
                              </TableCell>
                              <TableCell
                                align="center"
                                onClick={() => props.handleFileRowClick?.(row)}
                                sx={{ cursor: 'pointer', width: '120px' }}
                              >
                                {row.regDate}
                              </TableCell>
                              <TableCell align="center" sx={{ width: '80px' }}>
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    props.handleFileListDownload?.(row);
                                  }}
                                  sx={{
                                    color: '#1976d2',
                                    '&:hover': {
                                      backgroundColor: '#e3f2fd',
                                    },
                                  }}
                                >
                                  <DownloadIcon fontSize="small" />
                                </IconButton>
                              </TableCell>
                              <TableCell align="center" sx={{ width: '80px' }}>
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    props.handleFileListDelete?.(row);
                                  }}
                                  sx={{
                                    color: 'red',
                                    '&:hover': {
                                      backgroundColor: '#ffebee',
                                    },
                                  }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={5}
                              align="center"
                              sx={{ py: 3, color: 'text.secondary' }}
                            >
                              등록된 파일이 없습니다.
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>

                {/* 오른쪽: 미리보기 영역 */}
                <Paper
                  elevation={4}
                  sx={{
                    width: '50%',
                    p: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 3,
                    bgcolor: '#ffffff',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  <Typography
                    variant="h6"
                    mb={2}
                    sx={{ fontWeight: 'bold', color: '#666' }}
                  >
                    미리보기 영역
                  </Typography>
                  <Box
                    sx={{
                      border: '1px dashed #ccc',
                      borderRadius: 1,
                      flexGrow: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'auto',
                      minHeight: '500px',
                      bgcolor: '#fafafa',
                    }}
                  >
                    {tabValue === 0 ? (
                      props.renderPreview ? (
                        props.renderPreview()
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          미리보기 영역
                        </Typography>
                      )
                    ) : props.videoFile ? (
                      <video
                        controls
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          borderRadius: 8,
                        }}
                        src={URL.createObjectURL(props.videoFile)}
                        key={props.videoFile.name}
                      />
                    ) : props.videoUrl ? (
                      <video
                        controls
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          borderRadius: 8,
                        }}
                        src={props.videoUrl}
                        onError={(e) => console.error('❌ Video Load Error', e)}
                      >
                        <source src={props.videoUrl} type="video/mp4" />
                        브라우저가 video 태그를 지원하지 않습니다.
                      </video>
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        동영상 미리보기 영역
                      </Typography>
                    )}
                  </Box>
                </Paper>
              </Box>
            </Box>
          }
        />
      )}

      {props.modalToggle3 && (
        <Dialog
          title={'교육 자료 및 교육 동영상 등록'}
          open={props.modalToggle3}
          onClose={() => {
            props.setModalToggle3(false);
            setTabValue3(0); // 팝업 닫을 때 탭 초기화
          }}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            sx: {
              display: 'flex',
              flexDirection: 'column',
              height: '90vh',
              width: '80vw',
              bgcolor: '#f9fafb',
              p: 3,
            },
          }}
          useSaveAfterClose={false}
          closeButtonName="닫기"
          useSaveButton={false}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                height: '100%',
              }}
            >
              {/* 탭 영역 및 부서선택하러가기 버튼 */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  borderBottom: 2,
                  borderColor: 'divider',
                  mb: 2,
                }}
              >
                <Tabs
                  value={tabValue3}
                  onChange={(e, newValue) => {
                    setTabValue3(newValue);
                  }}
                  sx={{
                    flex: 1,
                    '& .MuiTabs-indicator': {
                      height: 3,
                      borderRadius: '3px 3px 0 0',
                    },
                  }}
                >
                  <Tab
                    label="📄 교육자료"
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '1rem',
                      minHeight: 48,
                      px: 3,
                      color: tabValue3 === 0 ? '#9c27b0' : '#666',
                      '&.Mui-selected': {
                        color: '#9c27b0',
                      },
                      '&:hover': {
                        color: '#9c27b0',
                        backgroundColor: 'rgba(156, 39, 176, 0.08)',
                      },
                    }}
                  />
                  <Tab
                    label="📹 교육동영상"
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '1rem',
                      minHeight: 48,
                      px: 3,
                      color: tabValue3 === 1 ? '#1976d2' : '#666',
                      '&.Mui-selected': {
                        color: '#1976d2',
                      },
                      '&:hover': {
                        color: '#1976d2',
                        backgroundColor: 'rgba(25, 118, 210, 0.08)',
                      },
                    }}
                  />
                </Tabs>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<DomainIcon />}
                  sx={{
                    height: 44,
                    whiteSpace: 'nowrap',
                    fontWeight: 'bold',
                    boxShadow: '0 3px 8px rgba(0,0,0,0.2)',
                    transition: 'all 0.3s ease',
                    ml: 2,
                    '&:hover': {
                      boxShadow: '0 5px 12px rgba(0,0,0,0.3)',
                    },
                  }}
                  onClick={() => {
                    // 파일이 없는 경우 경고창
                    const tempFileList3 = props.tempFileList3 || [];
                    const hasEduFiles = tempFileList3.some(
                      (f) => f.type === 'edu'
                    );
                    const hasVideoFiles = tempFileList3.some(
                      (f) => f.type === 'video'
                    );

                    if (!hasEduFiles && !hasVideoFiles) {
                      props.dispatch(
                        props.showSnackbar({
                          message:
                            '교육 자료 또는 교육 동영상을 업로드해주세요.',
                          type: 'warning',
                        })
                      );
                      return;
                    }

                    props.setSelectedBonbu([]);
                    props.setSelectedBuseo([]);
                    props.setSelectedTeam([]);
                    props.setSelectedPart([]);

                    props.setModalToggle3(false);
                    props.setModalToggle2(true);
                    props.fetchDepartmentData?.();
                  }}
                >
                  부서선택하러가기
                </Button>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  gap: 3,
                  flex: 1,
                  overflow: 'hidden',
                }}
              >
                {/* 왼쪽: 파일 선택 및 파일 리스트 */}
                <Paper
                  elevation={4}
                  sx={{
                    width: '50%',
                    p: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 3,
                    bgcolor: '#ffffff',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  <Typography
                    variant="h6"
                    mb={2}
                    sx={{
                      fontWeight: 'bold',
                      color: tabValue3 === 0 ? '#9c27b0' : '#1976d2',
                    }}
                  >
                    {tabValue3 === 0
                      ? '📄 교육 자료 업로드'
                      : '📹 교육 동영상 업로드'}
                  </Typography>

                  {/* 파일 선택 영역 */}
                  <Stack spacing={1} sx={{ mb: 2 }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Button
                        variant="contained"
                        component="label"
                        color={tabValue3 === 0 ? 'secondary' : 'primary'}
                        sx={{
                          bgcolor: tabValue3 === 0 ? '#9c27b0' : '#2196f3',
                        }}
                      >
                        {tabValue3 === 0 ? '자료 선택' : '동영상 선택'}
                        <input
                          type="file"
                          hidden
                          accept={
                            tabValue3 === 0
                              ? '.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.png,.jpg,.jpeg,.hwp'
                              : 'video/*'
                          }
                          onChange={
                            tabValue3 === 0
                              ? props.handleEduFileChange3
                              : props.handleVideoChange3
                          }
                        />
                      </Button>
                    </Stack>
                  </Stack>

                  {/* 파일 리스트 테이블 */}
                  <TableContainer sx={{ maxHeight: 400, mb: 2, flex: 1 }}>
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="center"
                            sx={{ fontWeight: 'bold', bgcolor: '#f5f5f5' }}
                          >
                            NO
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ fontWeight: 'bold', bgcolor: '#f5f5f5' }}
                          >
                            파일명
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ fontWeight: 'bold', bgcolor: '#f5f5f5' }}
                          >
                            등록일
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{ fontWeight: 'bold', bgcolor: '#f5f5f5' }}
                          >
                            삭제
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {props.tempFileList3 &&
                        props.tempFileList3.filter(
                          (f) => f.type === (tabValue3 === 0 ? 'edu' : 'video')
                        ).length > 0 ? (
                          props.tempFileList3
                            .filter(
                              (f) =>
                                f.type === (tabValue3 === 0 ? 'edu' : 'video')
                            )
                            .map((row, index) => (
                              <TableRow
                                key={row.id || index}
                                hover
                                sx={{
                                  '&:hover': {
                                    backgroundColor: '#f5f5f5',
                                  },
                                }}
                              >
                                <TableCell
                                  align="center"
                                  onClick={() =>
                                    props.handleTempFileRowClick3?.(row)
                                  }
                                  sx={{ cursor: 'pointer' }}
                                >
                                  {index + 1}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  onClick={() =>
                                    props.handleTempFileRowClick3?.(row)
                                  }
                                  sx={{ cursor: 'pointer' }}
                                >
                                  {row.fileName}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  onClick={() =>
                                    props.handleTempFileRowClick3?.(row)
                                  }
                                  sx={{ cursor: 'pointer' }}
                                >
                                  {row.regDate || '-'}
                                </TableCell>
                                <TableCell align="center">
                                  <IconButton
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      props.handleTempFileDelete3?.(row);
                                    }}
                                    sx={{
                                      color: 'red',
                                      '&:hover': {
                                        backgroundColor: '#ffebee',
                                      },
                                    }}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={4}
                              align="center"
                              sx={{ py: 3, color: 'text.secondary' }}
                            >
                              등록된 파일이 없습니다.
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>

                {/* 오른쪽: 미리보기 영역 */}
                <Paper
                  elevation={4}
                  sx={{
                    width: '50%',
                    p: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 3,
                    bgcolor: '#ffffff',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                  }}
                >
                  <Typography
                    variant="h6"
                    mb={2}
                    sx={{ fontWeight: 'bold', color: '#666' }}
                  >
                    미리보기 영역
                  </Typography>
                  <Box
                    sx={{
                      border: '1px dashed #ccc',
                      borderRadius: 1,
                      flexGrow: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      overflow: 'auto',
                      minHeight: '500px',
                      bgcolor: '#fafafa',
                    }}
                  >
                    {tabValue3 === 0 ? (
                      props.renderPreview ? (
                        props.renderPreview()
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          미리보기 영역
                        </Typography>
                      )
                    ) : props.tempPreviewVideoUrl ? (
                      <video
                        controls
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          borderRadius: 8,
                        }}
                        src={props.tempPreviewVideoUrl}
                        onError={(e) => {
                          console.log(
                            '❌ Video Load Error src=',
                            e.currentTarget?.currentSrc
                          );
                          console.log(
                            '❌ props.tempPreviewVideoUrl=',
                            props.tempPreviewVideoUrl
                          );
                          console.log(
                            '❌ networkState=',
                            e.currentTarget?.networkState,
                            'readyState=',
                            e.currentTarget?.readyState
                          );
                        }}
                      >
                        <source
                          src={props.tempPreviewVideoUrl}
                          type="video/mp4"
                        />
                        브라우저가 video 태그를 지원하지 않습니다.
                      </video>
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        동영상 미리보기 영역
                      </Typography>
                    )}
                  </Box>
                </Paper>
              </Box>
            </Box>
          }
        />
      )}

      {props.modalToggle2 && (
        <Dialog
          title="교육 자료 업로드 & 대상 부서 선택"
          open={props.modalToggle2}
          onClose={() => {
            props.setModalToggle2(false);
          }}
          maxWidth="xl"
          fullWidth
          saveButtonName={'저장'}
          closeButtonName={'닫기'}
          useSaveButton={true}
          useSaveAfterClose={false}
          onSave={() => {
            props.handleSave();
          }}
          PaperProps={{
            sx: {
              display: 'flex',
              flexDirection: 'column',
              height: '100vh',
              width: '70vw',
              bgcolor: '#f9fafb',
              p: 2,
            },
          }}
          content={
            <Box
              sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
            >
              <Box
                sx={{
                  mb: 1,
                  p: 1,
                  borderRadius: 2,
                  bgcolor: '#e0f2f1', // 연한 청록색 배경
                  border: '1px solid #b2dfdb',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<UploadFileIcon />}
                  onClick={() => {
                    props.setModalToggle2(false);
                    props.setModalToggle3(true);
                  }}
                  sx={{
                    ...buttonStyle,
                    mr: 2,
                  }}
                >
                  교육자료등록하러가기
                </Button>

                <InfoOutlinedIcon color="primary" />
                <Typography variant="body1" color="text.primary">
                  교육 자료를 등록할 대상을 선택해주세요
                </Typography>
              </Box>

              {/* 4단 선택 박스 */}
              <Box sx={{ display: 'flex', gap: 3, flexGrow: 1 }}>
                {/* 본부 */}
                <Paper
                  sx={{
                    flex: 1,
                    p: 2,
                    minHeight: 300,
                    bgcolor: '#d8eefdff',
                    overflowY: 'auto',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <BusinessIcon sx={{ mr: 1, color: '#1976d2' }} />
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 'bold', color: '#1976d2' }}
                    >
                      본부
                    </Typography>
                  </Box>
                  {props.renderCheckboxList(
                    props.bonbuList,
                    props.selectedBonbu,
                    (val) =>
                      props.toggleSelection(
                        val,
                        props.selectedBonbu,
                        props.setSelectedBonbu
                      )
                  )}
                </Paper>

                {/* 부서 */}
                <Paper
                  sx={{
                    flex: 1,
                    p: 2,
                    minHeight: 300,
                    bgcolor: '#f3e5f5',
                    overflowY: 'auto',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <ApartmentIcon sx={{ mr: 1, color: '#8e24aa' }} />
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 'bold', color: '#8e24aa' }}
                    >
                      부서
                    </Typography>
                  </Box>
                  {props.renderCheckboxList(
                    props.buseoList,
                    props.selectedBuseo,
                    (val) =>
                      props.toggleSelection(
                        val,
                        props.selectedBuseo,
                        props.setSelectedBuseo
                      )
                  )}
                </Paper>

                {/* 팀 */}
                <Paper
                  sx={{
                    flex: 1,
                    p: 2,
                    minHeight: 300,
                    bgcolor: '#e4f3d4ff',
                    overflowY: 'auto',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <GroupIcon sx={{ mr: 1, color: '#558b2f' }} />
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 'bold', color: '#558b2f' }}
                    >
                      팀
                    </Typography>
                  </Box>
                  {props.renderCheckboxList(
                    props.teamList,
                    props.selectedTeam,
                    (val) =>
                      props.toggleSelection(
                        val,
                        props.selectedTeam,
                        props.setSelectedTeam
                      )
                  )}
                </Paper>

                {/* 파트 */}
                <Paper
                  sx={{
                    flex: 1,
                    p: 2,
                    minHeight: 300,
                    bgcolor: '#fff3e0',
                    overflowY: 'auto',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <CategoryIcon sx={{ mr: 1, color: '#ef6c00' }} />
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 'bold', color: '#ef6c00' }}
                    >
                      파트
                    </Typography>
                  </Box>
                  {props.renderCheckboxList(
                    props.partList,
                    props.selectedPart,
                    (val) =>
                      props.toggleSelection(
                        val,
                        props.selectedPart,
                        props.setSelectedPart
                      )
                  )}
                </Paper>
              </Box>

              {/* 최종 선택 Chip 표시 영역 */}

              <Box
                sx={{
                  mt: 4,
                  p: 2,
                  border: '1px solid #90caf9',
                  borderRadius: 2,
                  bgcolor: '#f5f5f5',
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 'bold', color: '#1976d2', mb: 1 }}
                >
                  <AssignmentTurnedInIcon sx={{ mr: 1 }} />
                  등록 대상 목록
                </Typography>

                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {props.getFilteredSelectedItems().map((item, idx) => (
                    <Chip
                      key={idx}
                      label={`${item} (${props.getDepLevel(item)})`}
                      onDelete={() => {
                        if (props.selectedBonbu.includes(item)) {
                          props.setSelectedBonbu((prev) =>
                            prev.filter((i) => i !== item)
                          );
                        } else if (props.selectedBuseo.includes(item)) {
                          props.setSelectedBuseo((prev) =>
                            prev.filter((i) => i !== item)
                          );
                        } else if (props.selectedTeam.includes(item)) {
                          props.setSelectedTeam((prev) =>
                            prev.filter((i) => i !== item)
                          );
                        } else if (props.selectedPart.includes(item)) {
                          props.setSelectedPart((prev) =>
                            prev.filter((i) => i !== item)
                          );
                        }
                      }}
                    />
                  ))}
                </Stack>
              </Box>
            </Box>
          }
        />
      )}

      {/* 파일 삭제 확인 다이얼로그 */}
      <ConfirmDialog
        open={props.deleteConfirmOpen || false}
        title="파일 삭제"
        contentText={
          props.pendingDeleteFile
            ? `"${props.pendingDeleteFile.fileName}" 파일을 삭제하시겠습니까?`
            : '파일을 삭제하시겠습니까?'
        }
        onSave={props.handleFileListDeleteConfirm}
        onClose={() => props.setDeleteConfirmOpen?.(false)}
        saveButtonName="삭제"
        closeButtonName="취소"
      />
    </React.Fragment>
  );
}

export default TRA_CUSTOM_04;
